export default {};
//# sourceMappingURL=fr.js.map